import { render } from "./VSidebar.vue?vue&type=template&id=24bcb504&scoped=true"
import script from "./VSidebar.vue?vue&type=script&lang=js"
export * from "./VSidebar.vue?vue&type=script&lang=js"

import "./VSidebar.vue?vue&type=style&index=0&id=24bcb504&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bcb504"]])

export default __exports__